import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOnlineNew = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    id='onlineNew_svg__Layer_1'
    x={0}
    y={0}
    viewBox='0 0 566.9 566.9'
    {...props}
  >
    <style>{'.onlineNew_svg__st0{fill:var(--blue-1-active)}.onlineNew_svg__st1{fill:#157374}'}</style>
    <path
      d='M407.8 191.5v95.3c0 68.9-56.1 124.9-124.9 124.9h-47.6l-68.5 94.2H283c121 0 219.2-98.1 219.2-219.2v-91.3z'
      className='onlineNew_svg__st0'
    />
    <path
      d='M283.8 162.7h42.4l68.7-94.2H283.8c-121.1 0-219.2 98.1-219.2 219.2v73.8l94.2 5.5v-79.3c0-68.9 56.1-125 125-125'
      className='onlineNew_svg__st1'
    />
    <path
      d='M0 388.2c31.6-22.9 70.4-36.4 112.4-36.4 42.2 0 81.3 13.6 113 36.8l-113 154.9z'
      className='onlineNew_svg__st1'
    />
    <path
      d='M566.9 178.8c-31.6 22.9-70.4 36.4-112.4 36.4-42.2 0-81.3-13.6-113-36.8l113-154.9z'
      className='onlineNew_svg__st0'
    />
  </svg>
);
export default SvgOnlineNew;
